module.exports = __webpack_public_path__ + "static/img/pic3.c3c29d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case3/pic3.png
// module id = NZ+N
// module chunks = 1